import { call, put, select, takeLatest } from 'redux-saga/effects';
import { UPDATE_COMMUNICATION } from './constants';
import {
  updateCommunicationSuccess,
  updateCommunicationError,
} from './actions';

import history from 'utils/history';
import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';

// utils
import { endpoint } from 'utils/apis/axiosAPI';


export function* updateCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const localActiveChild = yield JSON.parse(
      localStorage.getItem('schoolinked_child'),
    );
    const newKey = 'nouvel';
    const prentID = currentUser?._id;
    const childID = localActiveChild?._id;

    const { itemDetail } = action;
   
    let updatedElement = false,
      isNew = !itemDetail.hasOwnProperty('_id');
    
    if (isNew && !!prentID && !!childID) {
      updatedElement = yield requestWrapper(
        'POST',
        endpoint?.parent?.communications?.new(prentID, childID),
        // `communications/parent/${prentID}/child/${childID}/new`,
        itemDetail,
        currentUser.token,
      );
    }
    
    if (!updatedElement) {
      yield put(updateCommunicationSuccess(false));
    } else {
      yield put(updateCommunicationSuccess(updatedElement));
    }
  } catch (err) {
    yield put(updateCommunicationError(true));
  }
}

// Individual exports for testing
export default function* communicationNewMobileSaga() {
  yield takeLatest(UPDATE_COMMUNICATION, updateCommunicationSaga);
}
